// Cronk Nutrients Feed Calculator
// Version: 1.1.0 — direct-to-cart bundle flow

(function() {
  'use strict';

  const FEED_CHARTS = {
    // Values are mL per gallon from official feed charts
    classic: [
      { week: 1, stage: 'Seedling', micro: 1.25, grow: 1.25, bloom: 1.25, calmag: 5.0, budBooster: 0, stickyBandit: 4, monkeyJuice: 4, armadillo: 0.5, ph: '5.6-5.9' },
      { week: 2, stage: 'Early Veg', micro: 2.50, grow: 2.50, bloom: 2.50, calmag: 5.0, budBooster: 0, stickyBandit: 4, monkeyJuice: 8, armadillo: 0.5, ph: '5.9-6.2' },
      { week: 3, stage: 'Mid Veg', micro: 2.50, grow: 2.50, bloom: 2.50, calmag: 5.0, budBooster: 0, stickyBandit: 4, monkeyJuice: 8, armadillo: 0.5, ph: '5.9-6.2' },
      { week: 4, stage: 'Late Veg', micro: 2.50, grow: 2.50, bloom: 2.50, calmag: 5.0, budBooster: 2, stickyBandit: 4, monkeyJuice: 8, armadillo: 0.5, ph: '5.9-6.2' },
      { week: 5, stage: 'Pre-Flower', micro: 5.00, grow: 5.00, bloom: 5.00, calmag: 5.0, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.4' },
      { week: 6, stage: 'Early Flower', micro: 5.00, grow: 5.00, bloom: 5.00, calmag: 5.0, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.4' },
      { week: 7, stage: 'Early Flower', micro: 5.00, grow: 2.50, bloom: 7.50, calmag: 5.0, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.4' },
      { week: 8, stage: 'Mid Flower', micro: 5.00, grow: 2.50, bloom: 7.50, calmag: 5.0, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.4' },
      { week: 9, stage: 'Mid Flower', micro: 5.00, grow: 2.50, bloom: 7.50, calmag: 5.0, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.4' },
      { week: 10, stage: 'Late Flower', micro: 5.00, grow: 1.50, bloom: 7.50, calmag: 5.0, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.4' },
      { week: 11, stage: 'Late Flower', micro: 2.00, grow: 0.00, bloom: 7.50, calmag: 5.0, budBooster: 8, stickyBandit: 8, monkeyJuice: 4, armadillo: 1.0, ph: '6.0-6.4' },
      { week: 12, stage: 'Late Flower', micro: 2.00, grow: 0.00, bloom: 7.50, calmag: 5.0, budBooster: 8, stickyBandit: 8, monkeyJuice: 0, armadillo: 1.0, ph: '6.0-6.4' },
      { week: 13, stage: 'Ripe', micro: 1.00, grow: 0.00, bloom: 7.50, calmag: 0.0, budBooster: 0, stickyBandit: 0, monkeyJuice: 0, armadillo: 0, ph: '6.0-6.4' },
      { week: 14, stage: 'Flush', micro: 0.00, grow: 0.00, bloom: 0.00, calmag: 0.0, budBooster: 0, stickyBandit: 0, monkeyJuice: 0, armadillo: 0, ph: '6.0-6.4' },
    ],
    autoflower: [
      { week: 1, stage: 'Seedling', bonnie: 0, clyde: 0, calmag: 2, budBooster: 0, stickyBandit: 1, monkeyJuice: 4, armadillo: 0.50, ph: '5.6-5.9' },
      { week: 2, stage: 'Early Veg', bonnie: 2, clyde: 0, calmag: 2, budBooster: 0, stickyBandit: 2, monkeyJuice: 4, armadillo: 0.50, ph: '5.9-6.2' },
      { week: 3, stage: 'Mid Veg', bonnie: 3.75, clyde: 0, calmag: 4, budBooster: 0, stickyBandit: 2, monkeyJuice: 8, armadillo: 0.50, ph: '5.9-6.2' },
      { week: 4, stage: 'Late Veg', bonnie: 5.75, clyde: 0, calmag: 4, budBooster: 0, stickyBandit: 4, monkeyJuice: 8, armadillo: 0.50, ph: '5.9-6.2' },
      { week: 5, stage: 'Pre-Flower', bonnie: 0, clyde: 9, calmag: 4, budBooster: 4, stickyBandit: 8, monkeyJuice: 8, armadillo: 0.50, ph: '6.0-6.4' },
      { week: 6, stage: 'Early Flower', bonnie: 0, clyde: 11, calmag: 4, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 0.50, ph: '6.0-6.4' },
      { week: 7, stage: 'Mid Flower', bonnie: 0, clyde: 11, calmag: 4, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 0.50, ph: '6.0-6.4' },
      { week: 8, stage: 'Mid Flower', bonnie: 0, clyde: 12, calmag: 4, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 0.50, ph: '6.0-6.4' },
      { week: 9, stage: 'Late Flower', bonnie: 0, clyde: 12, calmag: 4, budBooster: 8, stickyBandit: 8, monkeyJuice: 8, armadillo: 0.50, ph: '6.0-6.4' },
      { week: 10, stage: 'Ripen', bonnie: 0, clyde: 8, calmag: 0, budBooster: 8, stickyBandit: 8, monkeyJuice: 0, armadillo: 0, ph: '6.0-6.4' },
      { week: 11, stage: 'Flush', bonnie: 0, clyde: 0, calmag: 0, budBooster: 0, stickyBandit: 0, monkeyJuice: 0, armadillo: 0, ph: '6.0-6.4' },
    ],
    puur: [
      { week: 1, stage: 'Seedling', puurNitro: 2, puurPhos: 2, puurK: 5, puurCalMag: 2, puurBalance: 0.5, stickyBandit: 0, monkeyJuice: 4, armadillo: 0.5, ph: '6.0-6.5' },
      { week: 2, stage: 'Veg', puurNitro: 3, puurPhos: 2.5, puurK: 6, puurCalMag: 3, puurBalance: 1, stickyBandit: 4, monkeyJuice: 8, armadillo: 0.5, ph: '6.0-6.5' },
      { week: 3, stage: 'Veg', puurNitro: 5, puurPhos: 3, puurK: 6, puurCalMag: 4, puurBalance: 1, stickyBandit: 4, monkeyJuice: 8, armadillo: 0.5, ph: '6.0-6.5' },
      { week: 4, stage: 'Veg', puurNitro: 7, puurPhos: 3.5, puurK: 8, puurCalMag: 5, puurBalance: 1.5, stickyBandit: 4, monkeyJuice: 8, armadillo: 0.5, ph: '6.0-6.5' },
      { week: 5, stage: 'Flower', puurNitro: 7, puurPhos: 4, puurK: 9, puurCalMag: 5, puurBalance: 2, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.5' },
      { week: 6, stage: 'Flower', puurNitro: 6, puurPhos: 5, puurK: 10, puurCalMag: 5, puurBalance: 2, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.5' },
      { week: 7, stage: 'Flower', puurNitro: 5, puurPhos: 5, puurK: 10, puurCalMag: 5, puurBalance: 2, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.5' },
      { week: 8, stage: 'Flower', puurNitro: 4, puurPhos: 5, puurK: 10, puurCalMag: 5, puurBalance: 2, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.5' },
      { week: 9, stage: 'Flower', puurNitro: 3, puurPhos: 5, puurK: 10, puurCalMag: 5, puurBalance: 2, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.5' },
      { week: 10, stage: 'Flower', puurNitro: 2, puurPhos: 5, puurK: 10, puurCalMag: 5, puurBalance: 2, stickyBandit: 8, monkeyJuice: 8, armadillo: 1.0, ph: '6.0-6.5' },
      { week: 11, stage: 'Flower', puurNitro: 1, puurPhos: 5, puurK: 10, puurCalMag: 4, puurBalance: 2, stickyBandit: 8, monkeyJuice: 4, armadillo: 1.0, ph: '6.0-6.5' },
      { week: 12, stage: 'Flower', puurNitro: 0, puurPhos: 5, puurK: 10, puurCalMag: 2, puurBalance: 2, stickyBandit: 8, monkeyJuice: 0, armadillo: 1.0, ph: '6.0-6.5' },
      { week: 13, stage: 'Ripen', puurNitro: 0, puurPhos: 4, puurK: 8, puurCalMag: 0, puurBalance: 1, stickyBandit: 0, monkeyJuice: 0, armadillo: 0, ph: '6.0-6.5' },
      { week: 14, stage: 'Flush', puurNitro: 0, puurPhos: 0, puurK: 0, puurCalMag: 0, puurBalance: 0, stickyBandit: 0, monkeyJuice: 0, armadillo: 0, ph: '6.0-6.5' },
    ]
  };

  // Maps calc nutrient keys to Shopify product handles. Must stay in sync with
  // templates/page.build-your-bundle.json so both surfaces add the same variants.
  // PuurOrganics photoperiod charts by grow medium, verbatim from Ellis's gated export
  // (agents/product-director/outbox/puur-photo-charts-2026-10/puur-photoperiod-calculator.json).
  // FEED_CHARTS.puur above is no longer used: Puur reads its medium's chart from here.
  const PUUR_MEDIA = {"coco": {"name": "Coco coir", "ph": "6.2 on tap water; 5.8-6.2 on RO water", "note": "Feed every watering with 10-20% runoff. Make the first feed half strength.", "weeks": [{"label": "Veg 1", "stage": "Seedling", "water": false, "puurNitro": 4, "puurPhos": 1.5, "puurK": 1.75, "puurCalMag": 5.75, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 2", "stage": "", "water": false, "puurNitro": 5.5, "puurPhos": 1.75, "puurK": 2.75, "puurCalMag": 7.25, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 3", "stage": "Repeat for a longer veg", "water": false, "puurNitro": 6.5, "puurPhos": 2, "puurK": 3.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 4", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 2.5, "puurK": 3.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 1", "stage": "Flip to 12/12", "water": false, "puurNitro": 6.5, "puurPhos": 2.25, "puurK": 3.75, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 2", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 2, "puurK": 4, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 3", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 1.5, "puurK": 4.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 4", "stage": "", "water": false, "puurNitro": 5.75, "puurPhos": 1.5, "puurK": 4, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 5", "stage": "", "water": false, "puurNitro": 5, "puurPhos": 1, "puurK": 4, "puurCalMag": 7.5, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 6", "stage": "", "water": false, "puurNitro": 4, "puurPhos": 1, "puurK": 4, "puurCalMag": 6.75, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 7", "stage": "", "water": false, "puurNitro": 4, "puurPhos": 1.25, "puurK": 4, "puurCalMag": 5.75, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Flower 8", "stage": "", "water": false, "puurNitro": 3, "puurPhos": 1.25, "puurK": 3.75, "puurCalMag": 5.25, "puurBalance": 0.25, "armadillo": 0}, {"label": "Flower 9", "stage": "Repeat for longer strains", "water": false, "puurNitro": 3.25, "puurPhos": 1, "puurK": 3.5, "puurCalMag": 5.5, "puurBalance": 0.25, "armadillo": 0}, {"label": "Flower 10", "stage": "", "water": false, "puurNitro": 2.25, "puurPhos": 0.75, "puurK": 3.25, "puurCalMag": 5.25, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 11", "stage": "Final week", "water": false, "puurNitro": 0, "puurPhos": 0.5, "puurK": 0.75, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}]}, "promix": {"name": "Pro-Mix HP", "ph": "6.2-6.5", "note": "Plain pH'd water for week 1 (the bag's starter charge), then feed every watering with 10-20% runoff.", "weeks": [{"label": "Week 1", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Veg 2", "stage": "", "water": false, "puurNitro": 5.5, "puurPhos": 1.75, "puurK": 2.75, "puurCalMag": 7.25, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 3", "stage": "Repeat for a longer veg", "water": false, "puurNitro": 6.5, "puurPhos": 2, "puurK": 3.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 4", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 2.5, "puurK": 3.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 1", "stage": "Flip to 12/12", "water": false, "puurNitro": 6.5, "puurPhos": 2.25, "puurK": 3.75, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 2", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 2, "puurK": 4, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 3", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 1.5, "puurK": 4.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 4", "stage": "", "water": false, "puurNitro": 5.75, "puurPhos": 1.5, "puurK": 4, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 5", "stage": "", "water": false, "puurNitro": 5, "puurPhos": 1, "puurK": 4, "puurCalMag": 7.5, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 6", "stage": "", "water": false, "puurNitro": 4, "puurPhos": 1, "puurK": 4, "puurCalMag": 6.75, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 7", "stage": "", "water": false, "puurNitro": 4, "puurPhos": 1.25, "puurK": 4, "puurCalMag": 5.75, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Flower 8", "stage": "", "water": false, "puurNitro": 3, "puurPhos": 1.25, "puurK": 3.75, "puurCalMag": 5.25, "puurBalance": 0.25, "armadillo": 0}, {"label": "Flower 9", "stage": "Repeat for longer strains", "water": false, "puurNitro": 3.25, "puurPhos": 1, "puurK": 3.5, "puurCalMag": 5.5, "puurBalance": 0.25, "armadillo": 0}, {"label": "Flower 10", "stage": "", "water": false, "puurNitro": 2.25, "puurPhos": 0.75, "puurK": 3.25, "puurCalMag": 5.25, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 11", "stage": "Final week", "water": false, "puurNitro": 0, "puurPhos": 0.5, "puurK": 0.75, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}]}, "soil": {"name": "Bagged soil (pre-fertilized)", "ph": "6.2-6.5", "note": "Plain pH'd water for weeks 1-3, then start at Veg 2 when the starter fertilizer runs out.", "weeks": [{"label": "Week 1", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Week 2", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Week 3", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Veg 2", "stage": "", "water": false, "puurNitro": 5.5, "puurPhos": 1.75, "puurK": 2.75, "puurCalMag": 7.25, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 3", "stage": "Repeat for a longer veg", "water": false, "puurNitro": 6.5, "puurPhos": 2, "puurK": 3.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 4", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 2.5, "puurK": 3.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 1", "stage": "Flip to 12/12", "water": false, "puurNitro": 6.5, "puurPhos": 2.25, "puurK": 3.75, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 2", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 2, "puurK": 4, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 3", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 1.5, "puurK": 4.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 4", "stage": "", "water": false, "puurNitro": 5.75, "puurPhos": 1.5, "puurK": 4, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 5", "stage": "", "water": false, "puurNitro": 5, "puurPhos": 1, "puurK": 4, "puurCalMag": 7.5, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 6", "stage": "", "water": false, "puurNitro": 4, "puurPhos": 1, "puurK": 4, "puurCalMag": 6.75, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 7", "stage": "", "water": false, "puurNitro": 4, "puurPhos": 1.25, "puurK": 4, "puurCalMag": 5.75, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Flower 8", "stage": "", "water": false, "puurNitro": 3, "puurPhos": 1.25, "puurK": 3.75, "puurCalMag": 5.25, "puurBalance": 0.25, "armadillo": 0}, {"label": "Flower 9", "stage": "Repeat for longer strains", "water": false, "puurNitro": 3.25, "puurPhos": 1, "puurK": 3.5, "puurCalMag": 5.5, "puurBalance": 0.25, "armadillo": 0}, {"label": "Flower 10", "stage": "", "water": false, "puurNitro": 2.25, "puurPhos": 0.75, "puurK": 3.25, "puurCalMag": 5.25, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 11", "stage": "Final week", "water": false, "puurNitro": 0, "puurPhos": 0.5, "puurK": 0.75, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}]}, "autopot": {"name": "AutoPots / self-watering", "ph": "Reservoir 5.8 (5.8-6.0); change the batch at 6.2", "note": "Fill with the week's mix, top up with plain pH'd water. First tank half strength.", "weeks": [{"label": "Veg 1", "stage": "Seedling", "water": false, "puurNitro": 4, "puurPhos": 1.5, "puurK": 1.75, "puurCalMag": 5.75, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 2", "stage": "", "water": false, "puurNitro": 5.5, "puurPhos": 1.75, "puurK": 2.75, "puurCalMag": 7.25, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 3", "stage": "Repeat for a longer veg", "water": false, "puurNitro": 6.5, "puurPhos": 2, "puurK": 3.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Veg 4", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 2.5, "puurK": 3.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 1", "stage": "Flip to 12/12", "water": false, "puurNitro": 6.5, "puurPhos": 2.25, "puurK": 3.75, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 2", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 2, "puurK": 4, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 3", "stage": "", "water": false, "puurNitro": 6.5, "puurPhos": 1.5, "puurK": 4.5, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 4", "stage": "", "water": false, "puurNitro": 5.75, "puurPhos": 1.5, "puurK": 4, "puurCalMag": 8, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 5", "stage": "", "water": false, "puurNitro": 5, "puurPhos": 1, "puurK": 4, "puurCalMag": 7.5, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 6", "stage": "", "water": false, "puurNitro": 4, "puurPhos": 1, "puurK": 4, "puurCalMag": 6.75, "puurBalance": 0.25, "armadillo": 1}, {"label": "Flower 7", "stage": "", "water": false, "puurNitro": 4, "puurPhos": 1.25, "puurK": 4, "puurCalMag": 5.75, "puurBalance": 0.25, "armadillo": 0.5}, {"label": "Flower 8", "stage": "", "water": false, "puurNitro": 3, "puurPhos": 1.25, "puurK": 3.75, "puurCalMag": 5.25, "puurBalance": 0.25, "armadillo": 0}, {"label": "Flower 9", "stage": "Repeat for longer strains", "water": false, "puurNitro": 3.25, "puurPhos": 1, "puurK": 3.5, "puurCalMag": 5.5, "puurBalance": 0.25, "armadillo": 0}, {"label": "Flower 10", "stage": "", "water": false, "puurNitro": 2.25, "puurPhos": 0.75, "puurK": 3.25, "puurCalMag": 5.25, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 11", "stage": "Final week", "water": false, "puurNitro": 0, "puurPhos": 0.5, "puurK": 0.75, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}]}, "living": {"name": "Living soil", "ph": "6.2-6.5 every time", "note": "Feed only on the weeks shown; plain pH'd water all other weeks.", "weeks": [{"label": "Veg 1", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Veg 2", "stage": "", "water": false, "puurNitro": 0.8, "puurPhos": 0.25, "puurK": 0.4, "puurCalMag": 1.1, "puurBalance": 0.25, "armadillo": 0, "per5gal": {"puurNitro": 4, "puurPhos": 1.25, "puurK": 2, "puurCalMag": 5.5, "puurBalance": 1.25}}, {"label": "Veg 3", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Veg 4", "stage": "", "water": false, "puurNitro": 0.7, "puurPhos": 0.4, "puurK": 0.5, "puurCalMag": 1.2, "puurBalance": 0.25, "armadillo": 0, "per5gal": {"puurNitro": 3.5, "puurPhos": 2, "puurK": 2.5, "puurCalMag": 6, "puurBalance": 1.25}}, {"label": "Flower 1", "stage": "Flip to 12/12", "water": false, "puurNitro": 0.7, "puurPhos": 0.35, "puurK": 0.55, "puurCalMag": 1.2, "puurBalance": 0.25, "armadillo": 0, "per5gal": {"puurNitro": 3.5, "puurPhos": 1.75, "puurK": 2.75, "puurCalMag": 6, "puurBalance": 1.25}}, {"label": "Flower 2", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 3", "stage": "", "water": false, "puurNitro": 0.8, "puurPhos": 0.2, "puurK": 0.65, "puurCalMag": 1.2, "puurBalance": 0.25, "armadillo": 0, "per5gal": {"puurNitro": 4, "puurPhos": 1, "puurK": 3.25, "puurCalMag": 6, "puurBalance": 1.25}}, {"label": "Flower 4", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 5", "stage": "", "water": false, "puurNitro": 0.75, "puurPhos": 0.15, "puurK": 0.6, "puurCalMag": 1.1, "puurBalance": 0.25, "armadillo": 0, "per5gal": {"puurNitro": 3.75, "puurPhos": 0.75, "puurK": 3, "puurCalMag": 5.5, "puurBalance": 1.25}}, {"label": "Flower 6", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 7", "stage": "", "water": false, "puurNitro": 0.6, "puurPhos": 0.2, "puurK": 0.6, "puurCalMag": 0.85, "puurBalance": 0.0, "armadillo": 0, "per5gal": {"puurNitro": 3, "puurPhos": 1, "puurK": 3, "puurCalMag": 4.25, "puurBalance": 0}}, {"label": "Flower 8", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 9", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 10", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}, {"label": "Flower 11", "stage": "Plain pH'd water", "water": true, "puurNitro": 0, "puurPhos": 0, "puurK": 0, "puurCalMag": 0, "puurBalance": 0, "armadillo": 0}]}};
  const PUUR_MEDIUM_ORDER = ['coco', 'promix', 'soil', 'autopot', 'living'];
  const PUUR_KEYS = ['puurNitro', 'puurPhos', 'puurK', 'puurCalMag', 'puurBalance', 'armadillo'];
  const PUUR_ADDITIVE_NOTE = 'Monkey Juice and Sticky Bandit are optional. Use the rates on the additives chart (Monkey Juice once a week, added last after pH).';
  // Living soil's Veg 3 is a water week, so it gets its own extension rule (Ellis 2026-10-19).
  const PUUR_LONGER_NOTE = 'Longer veg: repeat Veg 3. Longer strains: repeat Flower 9.';
  const PUUR_LONGER_NOTE_LIVING = 'Longer veg: keep alternating a plain-water week with the Veg 4 feed. Longer strains: stay on plain water after Flower 7.';
  const puurLongerNote = (mediumKey) => (mediumKey === 'living' ? PUUR_LONGER_NOTE_LIVING : PUUR_LONGER_NOTE);

  // Puur amounts show to 2 decimals, trailing zeros dropped (0.25, not 0.3).
  function formatPuurMl(value) {
    return String(Number(value.toFixed(2)));
  }

  // One row per week of the selected medium's chart. Water weeks carry no product.
  function buildPuurSchedule(mediumKey, gallons, strength, include) {
    const medium = PUUR_MEDIA[mediumKey];
    return medium.weeks.map((w, i) => {
      const nutrients = {};
      if (!w.water) {
        PUUR_KEYS.forEach((k) => {
          if (include[k] === false) return;
          const ml = (w[k] || 0) * gallons * strength;
          if (ml > 0) nutrients[k] = formatPuurMl(ml);
        });
      }
      const per5 = !w.water && w.per5gal
        ? 'per 5 gal: ' + Object.entries(w.per5gal).map(([k, v]) => k.replace(/^puur/, 'Puur') + ' ' + v + ' mL').join(', ')
        : '';
      return {
        week: i + 1,
        stage: w.label,
        water: !!w.water,
        stageNote: w.water ? "Plain pH'd water" : [w.stage, per5].filter(Boolean).join('. '),
        nutrients,
        ph: medium.ph,
      };
    });
  }

  const PRODUCT_HANDLES = {
    micro: 'micro-5-0-1',
    grow: 'grow-2-1-6',
    bloom: 'bloom-0-5-3',
    bonnie: 'bonnie-autoflower-vegetation-fertilizer',
    clyde: 'clyde-autoflower-bloom-fertilizer',
    puurNitro: 'puurnitro-organic-nitrogen-supplement-8-0-0',
    puurPhos: 'puurphos-organic-phosphorus-supplement-0-12-0',
    puurK: 'puurk-0-0-15-organic-potassium-supplement',
    calmag: 'calmag-2-0-0',
    budBooster: 'bud-booster-0-1-3',
    monkeyJuice: 'monkey-juice-increases-root-health-and-nutrient-absorption',
    stickyBandit: 'sticky-bandit-0-0-1',
    armadillo: 'armadillo-armour-monosilicic-acid',
    puurCalMag: 'puurcalmag-organic-calcium-magnesium-supplement',
    puurBalance: 'puurbalance-organic-macro-micronutrients-2-0-0',
  };

  const BUNDLE_DISCOUNTS = (typeof window !== 'undefined' && window.CronkBundleConfig && window.CronkBundleConfig.tiers) || [];

  // Mirrors cart-rewards.liquid: $50+ subtotal -> free gift with _free_gift.
  const FREE_GIFT_CFG = (typeof window !== 'undefined' && window.CronkFreeGiftConfig) || {};
  const FREE_GIFT_VARIANT_ID = Number(FREE_GIFT_CFG.variantId || 0);
  const FREE_GIFT_THRESHOLD_CENTS = Number(FREE_GIFT_CFG.thresholdCents || 5000);
  const FREE_GIFT_LABEL = FREE_GIFT_CFG.label || 'Free Gift';
  function hasFreeGiftProperty(item) {
    return item?.properties?._free_gift === 'true';
  }

  function getGiftLineItems(cart, giftVariantId) {
    return (cart.items || []).filter((item) => {
      return hasFreeGiftProperty(item) || Number(item?.variant_id || item?.id || 0) === Number(giftVariantId);
    });
  }

  const WATER_PER_POT_BASE = {
    1: 0.25, 3: 0.75, 5: 1.25, 7: 1.75, 10: 2.5, 15: 3.75, 20: 5.0
  };

  function roundWaterUp(gallons) {
    if (gallons < 2) {
      return Math.ceil(gallons * 2) / 2;
    } else {
      return Math.ceil(gallons);
    }
  }

  function formatWaterPerPlant(totalGallons, plantCount) {
    const exactAmount = totalGallons / plantCount;
    const roundedAmount = Number(exactAmount.toFixed(2));
    const roundedAmountReconciles = Math.abs((roundedAmount * plantCount) - totalGallons) < 1e-9;

    return roundedAmountReconciles
      ? String(roundedAmount)
      : `${totalGallons} ÷ ${plantCount} ≈ ${roundedAmount}`;
  }

  function formatBottleSize(ml) {
    return ml >= 1000 ? (ml / 1000) + 'L' : ml + 'mL';
  }

  function recommendBottles(totalMl) {
    const bottles = [];
    let remaining = totalMl;
    
    while (remaining >= 4000) {
      bottles.push({ size: 4000, count: 1 });
      remaining -= 4000;
    }
    
    if (remaining > 3500) bottles.push({ size: 4000, count: 1 });
    else if (remaining > 3000) { bottles.push({ size: 1000, count: 3 }); bottles.push({ size: 500, count: 1 }); }
    else if (remaining > 2500) bottles.push({ size: 1000, count: 3 });
    else if (remaining > 2000) { bottles.push({ size: 1000, count: 2 }); bottles.push({ size: 500, count: 1 }); }
    else if (remaining > 1500) bottles.push({ size: 1000, count: 2 });
    else if (remaining > 1000) { bottles.push({ size: 1000, count: 1 }); bottles.push({ size: 500, count: 1 }); }
    else if (remaining > 500) bottles.push({ size: 1000, count: 1 });
    else if (remaining > 0) bottles.push({ size: 500, count: 1 });
    
    const consolidated = {};
    bottles.forEach(b => consolidated[b.size] = (consolidated[b.size] || 0) + b.count);
    
    return Object.entries(consolidated)
      .map(([size, count]) => ({ size: parseInt(size), count }))
      .sort((a, b) => b.size - a.size);
  }

  function initCalculator() {
    if (typeof React === 'undefined' || typeof ReactDOM === 'undefined') {
      setTimeout(initCalculator, 100);
      return;
    }

    const { useState, useMemo, useEffect, useRef, createElement: h } = React;
    const rootElements = document.querySelectorAll('[data-calculator-root]');
    
    if (!rootElements.length) return;

    function Calculator() {
      const [step, setStep] = useState(1);
      const [baseLine, setBaseLine] = useState('classic');
      const [puurMedium, setPuurMedium] = useState('coco');
      const [additives, setAdditives] = useState({});
      const [numPlants, setNumPlants] = useState(4);
      const [potSize, setPotSize] = useState(5);
      const [wateringFreq, setWateringFreq] = useState(1);
      const [vegWeeks, setVegWeeks] = useState(4);
      const [flowerWeeks, setFlowerWeeks] = useState(10);
      const [nutrientStrength, setNutrientStrength] = useState(1.0);
      const [customWaterAmount, setCustomWaterAmount] = useState(null);
      const [cartStatus, setCartStatus] = useState('idle'); // idle | loading | error
      const [cartError, setCartError] = useState('');
      const [bundlePricing, setBundlePricing] = useState({ subtotal: 0, bottleCount: 0, tier: null, savings: 0, ready: false });
      const productCacheRef = useRef({}); // handle -> { variants: [{title, price, available}], ... }

      useEffect(() => {
        if (baseLine === 'classic') {
          setAdditives({});
          setWateringFreq(1);
          setVegWeeks(4);
          setFlowerWeeks(10);
        } else if (baseLine === 'autoflower') {
          setAdditives({ calmag: true });
          setWateringFreq(1);
          setVegWeeks(4);
          setFlowerWeeks(7);
        } else if (baseLine === 'puur') {
          setAdditives({ puurCalMag: true, puurBalance: true });
          setWateringFreq(1);
          setVegWeeks(4);
          setFlowerWeeks(10);
        }
      }, [baseLine]);

      const toggleAdditive = (name) => setAdditives(prev => ({ ...prev, [name]: !prev[name] }));

      const canProceedToStep = (targetStep) => {
        if (targetStep === 1) return true;
        if (targetStep === 2) return baseLine !== null;
        if (targetStep === 3) return true;
        if (targetStep === 4) return numPlants > 0 && potSize > 0;
        return false;
      };

      const calculations = useMemo(() => {
        const waterBasePerPlant = WATER_PER_POT_BASE[potSize];
        const feedChart = FEED_CHARTS[baseLine];
        
        // Use custom water amount if set, otherwise use calculated amount
        const calculatedWater = roundWaterUp(waterBasePerPlant * numPlants);
        const actualWaterToUse = customWaterAmount !== null ? customWaterAmount : calculatedWater;
        
        let schedule = [];
        
        if (baseLine === 'autoflower') {
          const vegSchedule = feedChart.slice(0, 4);
          for (let i = 0; i < vegWeeks; i++) {
            if (i < 4) {
              schedule.push(vegSchedule[i]);
            } else {
              schedule.push({ ...feedChart[3], week: i + 1 });
            }
          }
          
          const flowerSchedule = feedChart.slice(4);
          for (let i = 0; i < flowerWeeks; i++) {
            if (i < flowerSchedule.length) {
              schedule.push(flowerSchedule[i]);
            } else {
              schedule.push({ ...feedChart[10], week: vegWeeks + i + 1 });
            }
          }
        } else {
          const vegSchedule = feedChart.slice(0, 4);
          for (let i = 0; i < vegWeeks; i++) {
            if (i < 4) {
              schedule.push(vegSchedule[i]);
            } else {
              schedule.push({ ...feedChart[3], week: i + 1 });
            }
          }
          
          const flowerSchedule = feedChart.slice(4);
          for (let i = 0; i < flowerWeeks; i++) {
            if (i < flowerSchedule.length) {
              schedule.push(flowerSchedule[i]);
            } else {
              schedule.push({ ...feedChart[feedChart.length - 1], week: vegWeeks + i + 1 });
            }
          }
        }

        const results = baseLine === 'puur'
          ? buildPuurSchedule(puurMedium, actualWaterToUse, nutrientStrength, {
              puurCalMag: !!additives.puurCalMag,
              puurBalance: !!additives.puurBalance,
              armadillo: !!additives.armadillo,
            }).map((w) => ({
              ...w,
              waterPerPlant: actualWaterToUse / numPlants,
              waterPerPlantDisplay: formatWaterPerPlant(actualWaterToUse, numPlants),
              totalWaterPerFeeding: actualWaterToUse,
            }))
          : schedule.map((week, idx) => {
          const waterPerPlant = actualWaterToUse / numPlants;

          const weekData = {
            week: idx + 1,
            stage: week.stage,
            waterPerPlant,
            waterPerPlantDisplay: formatWaterPerPlant(actualWaterToUse, numPlants),
            totalWaterPerFeeding: actualWaterToUse,
            ph: week.ph,
            stageNote: '',
            nutrients: {}
          };

          Object.keys(week).forEach(key => {
            if (!['week', 'stage', 'ph'].includes(key)) {
              if (baseLine === 'classic') {
                if (['micro', 'grow', 'bloom'].includes(key)) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                } else if (key === 'calmag' && additives.calmag) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                } else if (additives[key]) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                }
              } else if (baseLine === 'autoflower') {
                if (['bonnie', 'clyde'].includes(key)) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                } else if (key === 'calmag' && additives.calmag) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                } else if (additives[key]) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                }
              } else if (baseLine === 'puur') {
                if (['puurNitro', 'puurPhos', 'puurK'].includes(key)) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                } else if (key === 'puurCalMag' && additives.puurCalMag) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                } else if (key === 'puurBalance' && additives.puurBalance) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                } else if (additives[key]) {
                  weekData.nutrients[key] = (week[key] * actualWaterToUse * nutrientStrength).toFixed(1);
                }
              }
            }
          });

          return weekData;
        });

        const totals = {};
        results.forEach(week => {
          Object.entries(week.nutrients).forEach(([nutrient, amount]) => {
            if (!totals[nutrient]) totals[nutrient] = 0;
            const isOncePerWeek = ['budBooster', 'stickyBandit', 'monkeyJuice', 'armadillo'].includes(nutrient);
            const multiplier = isOncePerWeek ? 1 : wateringFreq;
            totals[nutrient] += parseFloat(amount) * multiplier;
          });
        });

        const recommendations = {};
        Object.entries(totals).forEach(([nutrient, totalMl]) => {
          const bottles = recommendBottles(totalMl);
          const weeksUsed = results.filter(w => parseFloat(w.nutrients[nutrient] || 0) > 0).length;
          recommendations[nutrient] = { total: totalMl.toFixed(0), bottles, weeksUsed, totalWeeks: results.length };
        });

        const totalWaterForGrow = results.reduce((sum, week) => sum + week.totalWaterPerFeeding * wateringFreq, 0);

        // Puur column set: every product that appears in any week (week 1 can be a water week).
        const puurColumns = baseLine === 'puur'
          ? Object.fromEntries(PUUR_KEYS.filter((k) => results.some((w) => w.nutrients[k] !== undefined)).map((k) => [k, true]))
          : null;
        return { 
          puurColumns,
          schedule: results, 
          recommendations, 
          waterBasePerPlant: waterBasePerPlant.toFixed(2),
          totalWaterPerFeeding: actualWaterToUse,
          recommendedWater: calculatedWater,
          totalWaterForGrow: roundWaterUp(totalWaterForGrow)
        };
      }, [baseLine, puurMedium, numPlants, potSize, wateringFreq, vegWeeks, flowerWeeks, additives, nutrientStrength, customWaterAmount]);

      // Collect the (handle, size, qty) line items from current recommendations.
      const bundleLineItems = useMemo(() => {
        const items = [];
        Object.entries(calculations.recommendations || {}).forEach(([nutrient, rec]) => {
          const handle = PRODUCT_HANDLES[nutrient];
          if (!handle || !rec.bottles || !rec.bottles.length) return;
          rec.bottles.forEach(b => {
            if (b.count > 0) items.push({ handle, size: formatBottleSize(b.size), sizeMl: b.size, quantity: b.count });
          });
        });
        return items;
      }, [calculations]);

      // Resolve a preferred (size, qty) line item to an in-stock variant, upsizing if needed.
      // If the preferred size is out of stock, fall back to the smallest AVAILABLE variant and
      // recompute quantity to cover the same total volume. Returns { variant, quantity } or null.
      function resolveAvailableVariant(product, preferredSizeMl, preferredQty) {
        if (!product) return null;
        const variantsWithMl = product.variants.map(v => {
          const m = /^(\d+(?:\.\d+)?)(mL|L)$/i.exec(v.title || '');
          const ml = m ? (m[2].toLowerCase() === 'l' ? parseFloat(m[1]) * 1000 : parseFloat(m[1])) : null;
          return { ...v, ml };
        }).filter(v => v.ml !== null);

        const preferred = variantsWithMl.find(v => v.ml === preferredSizeMl);
        if (preferred && preferred.available) {
          return { variant: preferred, quantity: preferredQty };
        }

        // Fall back: smallest available variant that's >= preferred, else any available.
        const available = variantsWithMl.filter(v => v.available).sort((a, b) => a.ml - b.ml);
        if (!available.length) return null;
        const upsize = available.find(v => v.ml >= preferredSizeMl) || available[available.length - 1];
        const totalMlNeeded = preferredSizeMl * preferredQty;
        const quantity = Math.max(1, Math.ceil(totalMlNeeded / upsize.ml));
        return { variant: upsize, quantity };
      }

      // When the line items change, make sure every handle is cached, then compute subtotal + tier + savings.
      useEffect(() => {
        let cancelled = false;

        const run = async () => {
          if (!bundleLineItems.length) {
            setBundlePricing({ subtotal: 0, bottleCount: 0, tier: null, savings: 0, ready: false });
            return;
          }

          const uniqueHandles = [...new Set(bundleLineItems.map(li => li.handle))];
          const missing = uniqueHandles.filter(h => !productCacheRef.current[h]);

          if (missing.length) {
            try {
              const responses = await Promise.all(
                missing.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null))
              );
              if (cancelled) return;
              responses.forEach((p, i) => { if (p) productCacheRef.current[missing[i]] = p; });
            } catch (err) {
              console.warn('Bundle price fetch failed:', err);
              return;
            }
          }

          // Use the same resolver the cart-add uses so the button price matches what actually lands.
          let subtotalCents = 0;
          let bottleCount = 0;
          bundleLineItems.forEach(li => {
            const product = productCacheRef.current[li.handle];
            const resolved = resolveAvailableVariant(product, li.sizeMl, li.quantity);
            if (!resolved) return;
            subtotalCents += resolved.variant.price * resolved.quantity;
            bottleCount += resolved.quantity;
          });

          const tier = BUNDLE_DISCOUNTS.find(t => bottleCount >= t.minItems) || null;
          const savingsCents = tier ? Math.round(subtotalCents * (tier.percent / 100)) : 0;

          if (!cancelled) {
            setBundlePricing({
              subtotal: subtotalCents / 100,
              bottleCount,
              tier,
              savings: savingsCents / 100,
              ready: true,
            });
          }
        };

        run();
        return () => { cancelled = true; };
      }, [bundleLineItems]);

      const addBundleToCart = async () => {
        setCartStatus('loading');
        setCartError('');

        try {
          if (!bundleLineItems.length) {
            throw new Error('No recommended products to add. Please complete the calculator first.');
          }

          // Make sure every handle is loaded in the cache (the pricing effect usually populated it already).
          const uniqueHandles = [...new Set(bundleLineItems.map(li => li.handle))];
          const toFetch = uniqueHandles.filter(h => !productCacheRef.current[h]);
          if (toFetch.length) {
            const responses = await Promise.all(
              toFetch.map(h => fetch(`/products/${h}.js`).then(r => {
                if (!r.ok) throw new Error(`Could not load product: ${h}`);
                return r.json();
              }))
            );
            responses.forEach((p, i) => { productCacheRef.current[toFetch[i]] = p; });
          }

          const items = [];
          const missing = [];
          bundleLineItems.forEach(li => {
            const product = productCacheRef.current[li.handle];
            const resolved = resolveAvailableVariant(product, li.sizeMl, li.quantity);
            if (resolved) {
              const properties = { '_source': 'feed-calculator' };
              items.push({
                id: resolved.variant.id,
                quantity: resolved.quantity,
                properties
              });
            } else {
              missing.push(`${li.handle} ${li.size}`);
            }
          });

          if (!items.length) {
            throw new Error(`No matching variants in stock: ${missing.join(', ')}`);
          }

          const totalQty = items.reduce((sum, it) => sum + it.quantity, 0);
          const tier = BUNDLE_DISCOUNTS.find(t => totalQty >= t.minItems);

          if (tier) {
            items.forEach(it => { it.properties['_bundle_discount'] = `${tier.percent}%`; it.properties['_bundle_item'] = 'true'; });
          }

          // Auto-add the free gift if the post-discount subtotal clears the $50 threshold.
          // Mirrors cart-rewards.liquid so customers who skip /cart still get the gift.
          const bundleSubtotalCents = items.reduce((sum, it) => {
            const product = Object.values(productCacheRef.current).find(p => p.variants.some(v => v.id === it.id));
            const variant = product && product.variants.find(v => v.id === it.id);
            return sum + (variant ? variant.price * it.quantity : 0);
          }, 0);
          const postDiscountCents = tier ? Math.round(bundleSubtotalCents * (1 - tier.percent / 100)) : bundleSubtotalCents;

          if (postDiscountCents >= FREE_GIFT_THRESHOLD_CENTS && FREE_GIFT_VARIANT_ID) {
            try {
              const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
              const cart = cartRes.ok ? await cartRes.json() : { items: [] };

              if (!cartRes.ok) {
                throw new Error(`Cart fetch failed: ${cartRes.status}`);
              }

              if (!getGiftLineItems(cart, FREE_GIFT_VARIANT_ID).length) {
                items.push({
                  id: FREE_GIFT_VARIANT_ID,
                  quantity: 1,
                  properties: { '_free_gift': 'true', 'Gift': FREE_GIFT_LABEL }
                });
              }
            } catch (err) {
              console.warn('Free gift fetch failed (non-fatal):', err);
            }
          }

          const addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });

          if (!addRes.ok) {
            const txt = await addRes.text();
            console.error('Cart add failed:', txt);
            throw new Error('Shopify rejected the add-to-cart request.');
          }

          // In theme editor iframe, just show success — can't redirect out of the preview.
          if (window.location.href.includes('/editor') || window.self !== window.top) {
            setCartStatus('idle');
            alert(`Added ${totalQty} bottles to cart${tier ? ` (${tier.code} — ${tier.percent}% off applied at checkout)` : ''}.`);
            return;
          }

          window.location.href = tier && tier.code ? `/discount/${encodeURIComponent(tier.code)}?redirect=/cart` : '/cart';
        } catch (err) {
          console.error('addBundleToCart error:', err);
          setCartStatus('error');
          setCartError(err.message || 'Something went wrong adding your bundle.');
        }
      };

      const downloadCSV = () => {
        try {
          const nutrientKeys = Object.keys(calculations.puurColumns || calculations.schedule[0].nutrients);
          const rows = [
            ['Cronk Nutrients Feed Schedule - VERIFIED FROM OFFICIAL CHARTS'],
            [`Base Line: ${baseLine.charAt(0).toUpperCase() + baseLine.slice(1)}`],
            [`Setup: ${numPlants} plants in ${potSize} gallon pots, watering ${wateringFreq}x/week`],
            [`Nutrient Strength: ${(nutrientStrength * 100).toFixed(0)}%`],
            [`Water per plant: ${calculations.waterBasePerPlant} gal`],
            [`Water to mix per feeding: ${calculations.totalWaterPerFeeding} gal${customWaterAmount !== null ? ' (CUSTOM)' : ''}`],
            [baseLine === 'puur' ? `Total: ${calculations.schedule.length}-week ${PUUR_MEDIA[puurMedium].name} chart` : `Total: ${vegWeeks + flowerWeeks} weeks (${vegWeeks} veg + ${flowerWeeks} flower)`],
            [`Total Water for the Whole Grow (all feedings): ${calculations.totalWaterForGrow} gallons`],
            [],
            ['Week', 'Stage', 'Water/Plant (gal)', 'Total Water to Mix (gal)', 'Stage Note', ...nutrientKeys.map(n => n.charAt(0).toUpperCase() + n.slice(1) + ' (mL total)'), 'pH'],
            ...calculations.schedule.map(week => [
              week.week, week.stage, week.waterPerPlantDisplay, week.totalWaterPerFeeding, week.stageNote,
              ...nutrientKeys.map(n => week.nutrients[n] || '0'), week.ph
            ]),
            [],
            ['BOTTLE RECOMMENDATIONS'],
            ['Nutrient', 'Total Needed (mL)', 'Recommended Bottles', 'Weeks Used'],
            ...Object.entries(calculations.recommendations).map(([nutrient, rec]) => [
              nutrient.charAt(0).toUpperCase() + nutrient.slice(1),
              rec.total,
              rec.bottles.map(b => `${b.count} x ${formatBottleSize(b.size)} Bottle`).join(', '),
              `${rec.weeksUsed} of ${rec.totalWeeks} weeks`
            ])
          ];

          const csvContent = rows.map(row => row.map(cell => {
            const cellStr = String(cell);
            return cellStr.includes(',') ? `"${cellStr}"` : cellStr;
          }).join(',')).join('\n');

          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          link.setAttribute('href', URL.createObjectURL(blob));
          link.setAttribute('download', baseLine === 'puur' ? `cronk-feed-puur-${puurMedium}.csv` : `cronk-feed-${baseLine}-${vegWeeks}v-${flowerWeeks}f.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } catch (error) {
          console.error('CSV error:', error);
          alert('Error downloading CSV');
        }
      };

      const renderStep1 = () => h('div', { className: 'glass-card' },
        h('h2', null, 'Step 1: Select Your Base Nutrient Line'),
        h('div', { className: 'help-text' }, 'Choose your nutrient system. Defaults based on your feed charts.'),
        h('div', { className: 'product-grid' },
          h('div', { className: `product-card ${baseLine === 'classic' ? 'selected' : ''}`, onClick: () => setBaseLine('classic') },
            h('h3', null, 'Classic Line'),
            h('p', null, 'Micro, Grow, Bloom 3-Part'),
            h('p', { style: { fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)', marginTop: '4px', opacity: 0.8 } }, 'Default: 4 veg + 10 flower')
          ),
          h('div', { className: `product-card ${baseLine === 'autoflower' ? 'selected' : ''}`, onClick: () => setBaseLine('autoflower') },
            h('h3', null, 'Autoflower Line'),
            h('p', null, 'Bonnie & Clyde 2-Part'),
            h('p', { style: { fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)', marginTop: '4px', opacity: 0.8 } }, 'Default: 4 veg + 7 flower')
          ),
          h('div', { className: `product-card ${baseLine === 'puur' ? 'selected' : ''}`, onClick: () => setBaseLine('puur') },
            h('h3', null, 'PuurOrganics Line'),
            h('p', null, '5-Part Organic'),
            h('p', { style: { fontSize: 'clamp(0.75rem, 2.5vw, 0.875rem)', marginTop: '4px', opacity: 0.8 } }, 'Photoperiod charts by grow medium')
          )
        ),
        h('div', { className: 'button-group single' },
          h('button', { className: 'btn btn-primary', onClick: () => setStep(2) }, 'Continue')
        )
      );

      const renderStep2 = () => h('div', { className: 'glass-card' },
        h('h2', null, 'Step 2: Select Additives (Optional)'),
        h('div', { className: 'help-text' }, 'Enhance your base nutrients. ', h('strong', null, 'Note:'), ' Bud Booster, Monkey Juice, Sticky Bandit, and Armadillo Armour applied 1x/week only.'),
        h('div', { className: 'checkbox-grid' },
          baseLine === 'puur' && h('div', { className: 'checkbox-card', onClick: () => toggleAdditive('puurCalMag') },
            h('input', { type: 'checkbox', checked: additives.puurCalMag || false, onChange: () => {} }),
            h('div', { className: 'checkbox-content' },
              h('div', { className: 'checkbox-title' }, 'PuurCalMag ', h('span', { className: 'badge' }, 'Recommended')),
              h('div', { className: 'checkbox-desc' }, 'Calcium and magnesium')
            )
          ),
          baseLine === 'puur' && h('div', { className: 'checkbox-card', onClick: () => toggleAdditive('puurBalance') },
            h('input', { type: 'checkbox', checked: additives.puurBalance || false, onChange: () => {} }),
            h('div', { className: 'checkbox-content' },
              h('div', { className: 'checkbox-title' }, 'PuurBalance ', h('span', { className: 'badge' }, 'Recommended')),
              h('div', { className: 'checkbox-desc' }, 'Essential micronutrients')
            )
          ),
          baseLine !== 'puur' && h('div', { className: 'checkbox-card', onClick: () => toggleAdditive('calmag') },
            h('input', { type: 'checkbox', checked: additives.calmag || false, onChange: () => {} }),
            h('div', { className: 'checkbox-content' },
              h('div', { className: 'checkbox-title' }, 'CalMag', baseLine === 'autoflower' && ' ', baseLine === 'autoflower' && h('span', { className: 'badge' }, 'Recommended')),
              h('div', { className: 'checkbox-desc' }, 'Prevents deficiencies')
            )
          ),
          baseLine !== 'puur' && h('div', { className: 'checkbox-card', onClick: () => toggleAdditive('budBooster') },
            h('input', { type: 'checkbox', checked: additives.budBooster || false, onChange: () => {} }),
            h('div', { className: 'checkbox-content' },
              h('div', { className: 'checkbox-title' }, 'Bud Booster'),
              h('div', { className: 'checkbox-desc' }, 'PK bloom booster (1x/week)')
            )
          ),
          baseLine === 'puur' && h('div', { className: 'help-text' }, PUUR_ADDITIVE_NOTE),
          baseLine !== 'puur' && h('div', { className: 'checkbox-card', onClick: () => toggleAdditive('stickyBandit') },
            h('input', { type: 'checkbox', checked: additives.stickyBandit || false, onChange: () => {} }),
            h('div', { className: 'checkbox-content' },
              h('div', { className: 'checkbox-title' }, 'Sticky Bandit'),
              h('div', { className: 'checkbox-desc' }, 'Carbs for terpenes (1x/week)')
            )
          ),
          baseLine !== 'puur' && h('div', { className: 'checkbox-card', onClick: () => toggleAdditive('monkeyJuice') },
            h('input', { type: 'checkbox', checked: additives.monkeyJuice || false, onChange: () => {} }),
            h('div', { className: 'checkbox-content' },
              h('div', { className: 'checkbox-title' }, 'Monkey Juice'),
              h('div', { className: 'checkbox-desc' }, 'Beneficial bacteria (1x/week)')
            )
          ),
          h('div', { className: 'checkbox-card', onClick: () => toggleAdditive('armadillo') },
            h('input', { type: 'checkbox', checked: additives.armadillo || false, onChange: () => {} }),
            h('div', { className: 'checkbox-content' },
              h('div', { className: 'checkbox-title' }, 'Armadillo Armour'),
              h('div', { className: 'checkbox-desc' }, 'Silica (1x/week)')
            )
          )
        ),
        h('div', { className: 'button-group' },
          h('button', { className: 'btn btn-secondary', onClick: () => setStep(1) }, 'Back'),
          h('button', { className: 'btn btn-primary', onClick: () => setStep(3) }, 'Continue')
        )
      );

      const renderStep3 = () => h('div', { className: 'glass-card' },
        h('h2', null, 'Step 3: Your Grow Setup'),
        h('div', { className: 'help-text' }, 
          h('strong', null, 'Recommended: '), 
          `${potSize}-gal pots get ${calculations.waterBasePerPlant} gal/feeding per plant (${numPlants} plants = ${calculations.recommendedWater} gal total).`
        ),
        h('div', { className: 'form-grid' },
          h('div', { className: 'form-group' },
            h('label', null, 'Number of Plants'),
            h('input', { 
              type: 'number', 
              min: '1', 
              value: numPlants, 
              onChange: (e) => {
                setNumPlants(parseInt(e.target.value) || 1);
                setCustomWaterAmount(null);
              }, 
              className: 'form-control' 
            })
          ),
          h('div', { className: 'form-group' },
            h('label', null, 'Pot Size'),
            h('select', { 
              value: potSize, 
              onChange: (e) => {
                setPotSize(parseInt(e.target.value));
                setCustomWaterAmount(null);
              }, 
              className: 'form-control' 
            },
              Object.keys(WATER_PER_POT_BASE).map(size => h('option', { key: size, value: size }, `${size} gallon`))
            )
          ),
          h('div', { className: 'form-group' },
            h('label', null, 'Watering Frequency'),
            h('select', { 
              value: wateringFreq, 
              onChange: (e) => setWateringFreq(parseInt(e.target.value)), 
              className: 'form-control' 
            },
              h('option', { value: '1' }, '1x per week'),
              h('option', { value: '2' }, '2x per week'),
              h('option', { value: '3' }, '3x per week'),
              h('option', { value: '7' }, 'Daily')
            )
          )
        ),
        
        // Water Override Section
        h('div', { className: 'water-override-control' },
          h('label', null, '💧 Water Amount Override (Optional)'),
          h('div', { className: 'water-override-desc' },
            `Recommended: ${calculations.recommendedWater} gallons. Change this if you want to mix a different amount.`
          ),
          h('div', { className: 'water-override-input-group' },
            h('input', { 
              type: 'number', 
              min: '0.5',
              max: '50',
              step: '0.5',
              value: customWaterAmount !== null ? customWaterAmount : calculations.recommendedWater,
              onChange: (e) => {
                const value = parseFloat(e.target.value);
                setCustomWaterAmount(value || null);
              },
              className: 'form-control',
              style: { flex: 1 }
            }),
            h('button', {
              className: 'btn btn-secondary',
              style: { 
                padding: '12px 16px', 
                fontSize: 'clamp(0.875rem, 2.5vw, 0.9375rem)',
                whiteSpace: 'nowrap'
              },
              onClick: () => setCustomWaterAmount(null)
            }, 'Reset')
          ),
          customWaterAmount !== null && customWaterAmount !== calculations.recommendedWater && h('div', { 
            className: 'water-override-status'
          },
            `✓ Using custom amount: ${customWaterAmount} gallons (${((customWaterAmount / calculations.recommendedWater) * 100).toFixed(0)}% of recommended)`
          )
        ),
        
        baseLine === 'puur' && h('div', { className: 'form-grid' },
          h('div', { className: 'form-group' },
            h('label', null, 'Grow Medium (photoperiod)'),
            h('select', { value: puurMedium, onChange: (e) => setPuurMedium(e.target.value), className: 'form-control' },
              PUUR_MEDIUM_ORDER.map((k) => h('option', { key: k, value: k }, PUUR_MEDIA[k].name))
            )
          )
        ),
        baseLine === 'puur' && h('div', { className: 'help-text' },
          h('strong', null, 'pH: '), PUUR_MEDIA[puurMedium].ph, '. ', PUUR_MEDIA[puurMedium].note, ' ', puurLongerNote(puurMedium)
        ),
        baseLine !== 'autoflower' && baseLine !== 'puur' && h('div', { className: 'form-grid' },
          h('div', { className: 'form-group' },
            h('label', null, 'Vegetative Weeks'),
            h('input', { 
              type: 'number', 
              min: '1', 
              max: '8', 
              value: vegWeeks, 
              onChange: (e) => setVegWeeks(parseInt(e.target.value) || 1), 
              className: 'form-control' 
            })
          ),
          h('div', { className: 'form-group' },
            h('label', null, 'Flowering Weeks'),
            h('input', { 
              type: 'number', 
              min: '1', 
              max: '12', 
              value: flowerWeeks, 
              onChange: (e) => setFlowerWeeks(parseInt(e.target.value) || 1), 
              className: 'form-control' 
            })
          )
        ),
        
        h('div', { className: 'strength-control' },
          h('label', null, '⚡ Nutrient Strength'),
          h('div', { className: 'strength-input-group' },
            h('input', { 
              type: 'range', 
              min: '0.5', 
              max: '1.5', 
              step: '0.1', 
              value: nutrientStrength, 
              onChange: (e) => setNutrientStrength(parseFloat(e.target.value)) 
            }),
            h('input', { 
              type: 'number', 
              min: '0.5', 
              max: '1.5', 
              step: '0.1', 
              value: nutrientStrength.toFixed(1), 
              onChange: (e) => setNutrientStrength(Math.max(0.5, Math.min(1.5, parseFloat(e.target.value) || 1.0))) 
            })
          ),
          h('div', { className: 'strength-label' },
            nutrientStrength < 0.8 ? '🔵 Light (Seedlings/Sensitive)' :
            nutrientStrength > 1.2 ? '🔴 Heavy (Experienced)' :
            '🟢 Standard (Recommended)'
          )
        ),
        
        h('div', { className: 'button-group' },
          h('button', { className: 'btn btn-secondary', onClick: () => setStep(2) }, 'Back'),
          h('button', { className: 'btn btn-primary', onClick: () => setStep(4) }, 'Calculate')
        )
      );

      const renderStep4 = () => h('div', { className: 'results-grid' },
        h('div', { className: 'glass-card' },
          h('h2', null, 'Bottle Recommendations'),
          h('div', { className: 'help-text' }, 
            h('strong', null, 'Summary: '), 
            `${numPlants} plants, ${potSize}-gal pots, ${wateringFreq}x/week, ${baseLine === 'puur' ? `${calculations.schedule.length}-week ${PUUR_MEDIA[puurMedium].name} chart` : `${vegWeeks + flowerWeeks} weeks (${vegWeeks}v+${flowerWeeks}f)`} at ${(nutrientStrength * 100).toFixed(0)}%. Mixing ${calculations.totalWaterPerFeeding} gallons per feeding${customWaterAmount !== null ? ' (CUSTOM)' : ''}.`
          ),
          h('div', { className: 'recommendation-grid' },
            Object.entries(calculations.recommendations).map(([nutrient, rec]) =>
              h('div', { key: nutrient, className: 'recommendation-card' },
                h('h4', null, nutrient.charAt(0).toUpperCase() + nutrient.slice(1).replace(/([A-Z])/g, ' $1')),
                h('div', { className: 'stat' }, h('strong', null, 'Used: '), `${rec.weeksUsed}/${rec.totalWeeks} weeks`),
                h('div', { className: 'stat' }, h('strong', null, 'Total: '), `${rec.total} mL`),
                h('div', { className: 'stat' }, h('strong', null, 'Recommend Size(s):')),
                h('div', { className: 'bottle-list' },
                  rec.bottles.map((b, i) => 
                    h('div', { key: i, className: 'bottle-item' }, `${b.count} x ${formatBottleSize(b.size)} Bottle`)
                  )
                )
              )
            )
          ),
          h('div', { className: 'button-group single' },
            h('button', {
              className: 'btn btn-primary',
              onClick: addBundleToCart,
              disabled: cartStatus === 'loading' || !bundleLineItems.length
            },
              cartStatus === 'loading'
                ? 'Adding to cart...'
                : bundlePricing.tier && bundlePricing.savings > 0
                  ? `🛒 Add Bundle to Cart · Save $${bundlePricing.savings.toFixed(2)} (${bundlePricing.tier.percent}% off)`
                  : '🛒 Add Bundle to Cart'
            )
          ),
          cartStatus === 'error' && h('div', {
            style: { marginTop: '12px', padding: '12px', background: 'rgba(239, 68, 68, 0.1)', border: '1px solid rgba(239, 68, 68, 0.4)', borderRadius: '8px', color: '#fecaca', fontSize: '14px' }
          }, cartError)
        ),

        h('div', { className: 'glass-card' },
          h('h2', null, 'Weekly Feed Schedule'),
          baseLine === 'puur' && h('div', { className: 'help-text' },
            h('strong', null, PUUR_MEDIA[puurMedium].name + ': '), 'pH ', PUUR_MEDIA[puurMedium].ph, '. ', PUUR_MEDIA[puurMedium].note, ' ', puurLongerNote(puurMedium), ' ', PUUR_ADDITIVE_NOTE
          ),
          h('div', { className: 'help-text' }, 
            h('strong', null, 'How to Use: '), 
            `Mix the nutrients shown below into ${calculations.totalWaterPerFeeding} gallons of water${customWaterAmount !== null ? ' (YOUR CUSTOM AMOUNT)' : ''}. Feed this mix ${wateringFreq}x/week at ${(nutrientStrength * 100).toFixed(0)}% strength. The numbers show total mL to add to your water. Bud Booster, Monkey Juice, Sticky Bandit, & Armadillo Armour are applied 1x/week only.`
          ),
          
          h('div', { className: 'total-water-stat' },
            h('div', { className: 'total-water-label' }, '💧 Total Water for the Whole Grow (all feedings)'),
            h('div', { className: 'total-water-value' }, `${calculations.totalWaterForGrow} gal`),
            h('div', { className: 'total-water-note' }, `This is all the water for the whole ${baseLine === 'puur' ? calculations.schedule.length : vegWeeks + flowerWeeks}-week grow, not one feeding: ${calculations.totalWaterPerFeeding} gal per feeding x ${wateringFreq} feedings a week x ${vegWeeks + flowerWeeks} weeks. The mL to add each time are in the table below. Plain waterings between feedings are recommended, especially in late veg and throughout flower.`)
          ),

          h('div', { className: 'scroll-hint' }, '👉 Scroll right to see all nutrients'),
          h('div', { style: { display: 'flex', justifyContent: 'center', marginBottom: '16px' } },
            h('button', { className: 'btn btn-secondary', style: { width: 'auto' }, onClick: downloadCSV }, '📥 Download CSV')
          ),
          h('div', { className: 'calc-table-wrapper' },
            h('table', { className: 'calc-table' },
              h('thead', null,
                h('tr', null,
                  h('th', null, 'Wk'), 
                  h('th', null, 'Stage'), 
                  h('th', null, 'Gal/Plant'), 
                  h('th', null, 'Total Gal to Mix'),
                  ...Object.keys(calculations.puurColumns || calculations.schedule[0].nutrients).map(n => 
                    h('th', { key: n }, n.charAt(0).toUpperCase() + n.slice(1).substring(0, 6) + ' (mL)')
                  ),
                  h('th', null, 'pH')
                )
              ),
              h('tbody', null,
                calculations.schedule.map((week, idx) =>
                  h('tr', { key: idx, className: week.stage === 'Flush' ? 'flush-week' : '' },
                    h('td', null, week.week),
                    h('td', null, week.stage + (week.stageNote ? ' ' + week.stageNote : '')),
                    h('td', null, week.waterPerPlantDisplay),
                    h('td', null, week.totalWaterPerFeeding),
                    ...Object.keys(calculations.puurColumns || calculations.schedule[0].nutrients).map(n => 
                      h('td', { key: n }, week.water ? "Plain pH'd water" : (parseFloat(week.nutrients[n] || 0) > 0 ? week.nutrients[n] : '—'))
                    ),
                    h('td', null, week.ph)
                  )
                )
              )
            )
          )
        ),

        h('div', { className: 'button-group' },
          h('button', { className: 'btn btn-secondary', onClick: () => setStep(3) }, 'Back'),
          h('button', { className: 'btn btn-primary', onClick: () => setStep(1) }, 'Start Over')
        )
      );

      return h('div', { className: 'calc-container' },
        h('div', { className: 'calc-header' },
          h('h1', null, 'Cronk Nutrients ', h('span', { className: 'highlight' }, 'Feed Calculator')),
          h('p', null, 'Calculate exact nutrient needs from seed to harvest')
        ),

        h('div', { className: 'beta-warning' },
          h('div', { className: 'beta-warning-content' },
            h('div', { className: 'beta-warning-icon' }, '⚠️'),
            h('div', null,
              h('div', { className: 'beta-warning-title' }, 'Beta Calculator - Use with Caution'),
              h('div', { className: 'beta-warning-text' },
                'This calculator is in ', h('strong', null, 'beta testing'), '. While based on our official feed charts, results should be ', h('strong', null, 'verified against '),
                h('a', { 
                  href: 'https://growers.cronknutrients.com/en-US/feeding-charts-for-cronk-nutrients-lines-2641633',
                  target: '_blank',
                  rel: 'noopener noreferrer'
                }, 'official charts'),
                ' before use. Always start with lower nutrient strengths and monitor your plants closely. Contact ',
                h('a', { href: 'mailto:help@cronknutrients.com' }, 'help@cronknutrients.com'),
                ' with any questions.'
              )
            )
          )
        ),

        h('div', { className: 'progress-circles' },
          [1, 2, 3, 4].map(num => h('div', {
            key: num,
            className: `progress-circle ${step === num ? 'active' : step > num ? 'completed' : ''}`,
            onClick: () => { if (canProceedToStep(num) && num <= step) setStep(num); },
            style: { cursor: canProceedToStep(num) && num <= step ? 'pointer' : 'not-allowed', opacity: canProceedToStep(num) || num <= step ? 1 : 0.5 }
          }, num))
        ),

        step === 1 && renderStep1(),
        step === 2 && renderStep2(),
        step === 3 && renderStep3(),
        step === 4 && renderStep4()
      );
    }

    rootElements.forEach(rootElement => {
      try {
        const root = ReactDOM.createRoot(rootElement);
        root.render(h(Calculator));
      } catch (error) {
        console.error('Calculator error:', error);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalculator);
  } else {
    initCalculator();
  }
})();
